import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { QueryClientProvider, QueryClient } from "react-query";
import { LanguageProvider } from "./context/LangContext";
import "./index.css";

// Create a client
const queryClient = new QueryClient();

ReactDOM.render(
  <BrowserRouter>
    <LanguageProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </LanguageProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
